import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

//i18n
import { withTranslation } from "react-i18next";

// users
import avatar2 from '../../../assets/images/users/avatar-2.jpg';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import withRouter from '../../Common/withRouter';
import { getAttachment, getProfileAttachment, verify_admin } from '../../../store/actions';
import { Avatar } from '@mui/material';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            username: "Aspeed"
        };
        this.toggle = this.toggle.bind(this);
    }


    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    componentDidMount() {
        // this.props.verify_admin()
        const data = this.props?.verifyAdmin?.user?.data?.profile?.name;
        if (data) {
            this.setState({ username: data })
        } else {
            // this.props.verify_admin()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.verifyAdmin !== prevProps.verifyAdmin) {
            const data = this.props.verifyAdmin && this.props.verifyAdmin?.user?.data?.profile?.name;
            const profileImg = this.props.verifyAdmin?.user?.data?.profile?.profile_photo_path;
            if (data) {
                this.setState({ username: data })
            }
            // if(profileImg){
            //     this.props.getProfileAttachment({attachment: profileImg});
            // }
        }
        // Now you can use the 'username' variable as needed.
    }

    render() {
        const profileImg = this.props.verifyAdmin?.user?.data?.profile?.profile_photo_path;
        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block user-dropdown">
                    <DropdownToggle tag="button" className="btn header-item waves-effect d-flex align-items-center" id="page-header-user-dropdown">
                        <span className="d-xl-inline-block ms-1 text-transform text-semibold">{this.state.username}</span>
                        <Avatar alt="Profile Pic" className='mx-2' src={profileImg} sx={{ width: 30, height: 30 }} />
                        <i className="ri-arrow-down-s-line"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        <Link to="/profile"><DropdownItem><i className="ri-account-circle-line align-middle me-2" style={{ fontSize: 18 }} /> {this.props.t('Profile')}</DropdownItem></Link>
                        <Link to="/logout"><DropdownItem className="text-danger border-top"><i className="ri-logout-box-r-line align-middle me-2 text-danger" style={{ fontSize: 18 }} />{this.props.t('Logout')}</DropdownItem></Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { verifyAdmin } = state.Login;
    const  profileImgBase64  = state.General.profileAttachment.base64_data;
    return { verifyAdmin, profileImgBase64 };
}

export default withTranslation()(withRouter(connect(mapStatetoProps, { verify_admin, getProfileAttachment })(ProfileMenu)));
